import {
  Modal,
  ModalContent,
  ModalBody,
  ModalFooter,
  ModalOverlay,
  Text,
  HStack,
} from '@chakra-ui/react';
import { t } from 'i18next';

type CheckoutErrorModalProps = {
  isOpen: boolean;
  message: string;
  onClose: () => void;
};

export default function CheckoutErrorModal({ isOpen, message, onClose }: CheckoutErrorModalProps) {
  return (
    <Modal size="xs" isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalBody p={5}>
          <Text textAlign="center">{message}</Text>
        </ModalBody>
        <ModalFooter p={0}>
          <HStack
            w="full"
            justify="center"
            cursor="pointer"
            p={2}
            borderTopWidth="1px"
            onClick={onClose}
          >
            <Text>{t('understood')}</Text>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
